export const tpoPrimaryColor = '#005eb8';
export const tpoFocusColor = '#ffeb3b';
export const tpoErrorColor = '#d5281b';
